<script setup lang="ts">
    import DialogForm from '@/components/DialogForm.vue';
    import { Button } from '@/components/ui/button';
    import { useForm } from '@inertiajs/vue3';
    import TransferEconomicForm from '@/components/bank/TransferEconomicForm.vue';
    import { ChevronRight } from 'lucide-vue-next';
    import { Row } from '@tanstack/table-core';
    import type { ViiaAccount } from '@/types';
    import { computed } from 'vue';
    import QueryKey from '@/enums/QueryKey';

    const props = defineProps<{
        selectedCompanyId: number;
        accountId: string;
        selectedRows: Row<any>[];
        dbAccount: ViiaAccount;
    }>();

    const transactions = computed(() => {
        return props.selectedRows.map((row) => row.id);
    });

    const form = useForm({
        cashbook_id: null,
        cashBookType: 5, // Finance Voucher
        contra_account_nr: null,
    });
</script>

<template>
    <DialogForm
        type="create"
        :form="form"
        :route="route('v2.transactions.transfer-economic', selectedCompanyId)"
        :query-key="[QueryKey.TRANSACTIONS, selectedCompanyId, accountId]"
        title="viia.transactions.transfer-economic"
        submit-text="viia.transactions.transfer-economic"
        :transform="
            (data) => ({
                ...data,
                transactions: transactions,
                accountId: accountId,
            })
        "
    >
        <template #trigger>
            <Button
                variant="ghost"
                width="narrow"
                class="self-start"
                size="xs"
                :disabled="!selectedRows.length"
            >
                {{ $t('viia.transactions.transfer-economic') }}
                ({{ selectedRows.length }})
                <ChevronRight class="text-accent" />
            </Button>
        </template>
        <TransferEconomicForm
            :form="form"
            :db-account="dbAccount"
        />
    </DialogForm>
</template>
